import {useSelector} from 'react-redux';
import {get, isNil} from 'lodash';

import {MetricsSection} from '/constant/TestIDs';
import {REPORT_ALL_CANDIDATES, REPORT_ALL_REFERRALS} from '/enum/records.enum';
import {useTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';

export function useCandidatesSection({
  onShowInfoPopover,
  onShowReport,
  allCandidatesCount,
  referralsCount,
}: any) {
  const {tt, ts} = useTranslation('screen.clients.section.orders');
  const featureFlag = useSelector(variablesFeatureFlag);
  const updateClientReferrel = shouldReleaseFeature(
    get(featureFlag, 'ff_client_referrel', ''),
  );

  //If showAddCandidate is true, candidate count is not 0, undefined, null, display candidate report
  const showAllCandidatesReport = featureFlag.showAddCandidate
    ? allCandidatesCount !== 0 && !isNil(allCandidatesCount)
    : true;

  const listItems = [];

  // Add All Candidates only if showAllCandidatesReport is true
  if (showAllCandidatesReport) {
    listItems.push({
      label: tt('all.candidates', 'All Candidates'),
      value: allCandidatesCount,
      recordsName: REPORT_ALL_CANDIDATES,
      testID: MetricsSection.metricAllCandidates,
    });
  }

  // Add Referrals only if updateClientReferrel is true
  if (updateClientReferrel) {
    listItems.push({
      label: tt('all.referrals', 'Referrals'),
      value: referralsCount,
      recordsName: REPORT_ALL_REFERRALS, // need to redirect to referral Report list later
      readonly: referralsCount === 0 || isNil(referralsCount),
    });
  }

  const onInfoPress = () =>
    onShowInfoPopover({
      heading: tt('info.heading', 'Candidates'),
      body: tt(
        'info.body',
        'These candidates have shown potential interest in being on-plan. Work with them to develop their healthy habits',
      ),
    });

  const onItemPress = ({recordsName, value}: any) =>
    onShowReport({
      recordsName,
      allCandidatesCount,
      loadingData: {total: value},
    });

  return {listItems, onInfoPress, onItemPress, tt, ts, featureFlag};
}
